@if (total() > 1 || !ocultarComUmItem()) {
  <div class="indicador-paginas" [style.gap.px]="espaco()">
    @for (bolinha of bolinhas(); track bolinha.indice) {
      <button type="button" class="indicador-paginas-bolinha" [style.width.px]="bolinha.largura" [style.height.px]="bolinha.altura"
              [attr.aria-label]="rotulo() + ' ' + (bolinha.indice + 1)" [attr.aria-current]="bolinha.indice === ativo()"
              (click)="selecionar.emit(bolinha.indice)">
        <span class="indicador-paginas-preenchimento" [style.opacity]="bolinha.destaque"></span>
      </button>
    }
  </div>
}
